import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '../store';
import moment from 'moment-timezone';
import da from '@/locales/da';
import de from '@/locales/de';
import en from '@/locales/en';
import nb from '@/locales/nb';
import pt from '@/locales/pt';
import sv from '@/locales/sv';

function getInitialLocale() {
  const storeLocale = store.state.appSettings.locale;
  if (storeLocale) return storeLocale;
  
  // Detect locale from domain if not in store
  const host = window.location.hostname;
  if (host.endsWith('.dk')) return 'da';
  if (host.endsWith('.se')) return 'sv';
  if (host.endsWith('.no')) return 'nb';
  if (host.endsWith('.pt')) return 'pt';
  if (host.endsWith('.de')) return 'de';
  if (host.endsWith('.at')) return 'de';
  if (host.endsWith('.ch')) return 'de';
  return 'en';
}

const initialLocale = getInitialLocale();

// Update store with detected locale if it's not already set
if (!store.state.appSettings.locale) {
  store.dispatch('appSettings/update', { locale: initialLocale });
}

/**
 * Configure VueI18n
 */
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: 'en',
  messages: {
    da, de, en, nb, pt, sv,
  },
});

/**
 * Configure moment.js and vue bindings
 */
moment.locale(initialLocale);

window.Vue = Vue;

/**
 * Subscribe to locale changes in the Vuex store
 */
function handleLocaleChange(locale) {
  i18n.locale = locale;
  moment.locale(locale);
}

store.watch(
  state => state.appSettings.locale,
  handleLocaleChange,
);

if (process.env.NODE_ENV === 'development') {
  window.changeLocale = locale => store.dispatch('appSettings/update', { locale });
}

export default i18n;
